import { gql } from '@apollo/client';

export const GET_PPV_AUTO_FREE_SETTING = gql`
  query GetPpvAutoFreeSetting {
    getPpvAutoFreeSetting {
      isEnabled
      hours
    }
  }
`;

export const COUNT_AUTO_FREED_PPV_STREAMS = gql`
  query CountAutoFreedPpvStreams {
    countAutoFreedPpvStreams
  }
`;
